import _classCallCheck from "/Users/eddieruiz/2024AiNomads/NomadHub/AiNomadsHub/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/eddieruiz/2024AiNomads/NomadHub/AiNomadsHub/node_modules/@babel/runtime/helpers/esm/createClass";
import { Random } from "./Random";
import { setRangeValue } from "../../Utils/NumberUtils";
export var ValueWithRandom = /*#__PURE__*/function () {
  function ValueWithRandom() {
    _classCallCheck(this, ValueWithRandom);
    this.random = new Random();
    this.value = 0;
  }
  _createClass(ValueWithRandom, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (typeof data.random === "boolean") {
        this.random.enable = data.random;
      } else {
        this.random.load(data.random);
      }
      if (data.value !== undefined) {
        this.value = setRangeValue(data.value, this.random.enable ? this.random.minimumValue : undefined);
      }
    }
  }]);
  return ValueWithRandom;
}();